import {Component} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    standalone: true,
    imports: [MatDividerModule]
})
export class DividerComponent {}
